/**
 * Wat de beheerder en de leerkracht allebei aan de server vragen: de
 * stellingen en de persona's, alleen-lezen. Beide api's (beheer.js en
 * leerkracht.js) nemen dit op, zodat het één keer geschreven staat.
 */
export function maakJson(verzoek) {
  const json = async (pad, opties) => (await verzoek(pad, opties)).json();
  const metBody = (method) => (pad, body) => json(pad, {
    method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  return {
    json,
    post: metBody('POST'),
    put: metBody('PUT'),
    verwijder: (pad) => json(pad, { method: 'DELETE' }),
    // Sommige endpoints nemen hun gegevens als queryparameters, niet als
    // JSON. Dat is de buitenkant, en die blijft zoals hij is.
    postParams: (pad, params) => json(pad + '?' + new URLSearchParams(params), { method: 'POST' }),
  };
}

export function stellingenEnPersonas({ json }) {
  return {
    haalStellingen: () => json('/admin/statements'),
    haalStelling: (id) => json('/admin/statements/' + id),
    /** Alleen de standaardpersona's; dat is de enige lijst die de app nog kent. */
    haalPersonas: async () => {
      const data = await json('/admin/personas');
      return data.success ? { ...data, data: data.data.standaard || [] } : data;
    },
    haalPersona: (id) => json('/admin/personas/' + id),
  };
}
